import { debounce } from "../../../components/debounce";
import * as bootstrap from "bootstrap";

// Check if the current page is the cart page
const isCartPage = () => document.querySelector("body.woocommerce-cart") !== null;

export const wooCart = (() => {
	if (!isCartPage()) return;

	// Update the cart when quantity buttons are clicked or input changes
	const attachCartListeners = () => {
		document.addEventListener("click", (e) => {
			if (e.target.classList.contains("qty_button")) {
				debounce(updateCart, 250);
			}
		});

		document.addEventListener("input", (e) => {
			if (e.target.id === "#coupon_code" || e.inputType === "deleteContentBackward" || e.inputType === "deleteContentForward") {
				return;
			}
			debounce(updateCart, 350);
		});

		focusCouponOnCollapse();
	};

	const focusCouponOnCollapse = () => {
		document.getElementById("coupon-collapse")?.addEventListener("shown.bs.collapse", () => {
			document.querySelector('input[name="coupon_code"')?.focus();
		});
	};

	// Update the cart
	const updateCart = () => {
		document.querySelector('.woocommerce-cart-form button[type="submit"]')?.click();
	};

	// Show toasts when cart is updated
	const showToasts = () => {
		const toastEls = document.querySelectorAll(".woocommerce-message .toast");
		if (!toastEls.length) return;

		const toasts = [...toastEls].map((toastEl) => new bootstrap.Toast(toastEl, { delay: 2000 }));

		toasts.forEach((toast) => {
			toast.show();
		});
	};

	// Observe changes in the "Proceed to Checkout" section
	const setProceedToCheckoutObserver = () => {
		const options = {
			threshold: 0.5,
		};

		const bannerObserverCallback = (entries, bannerObserver) => {
			const topBanner = document.querySelector(".cart-top-banner");
			if (!topBanner) return;

			entries.forEach((entry) => {
				topBanner.classList.toggle("hide", entry.isIntersecting);
			});
		};

		const observeBanner = (target) => {
			const bannerObserver = new IntersectionObserver(bannerObserverCallback, options);
			bannerObserver.observe(target);
			return bannerObserver;
		};

		const target = document.querySelector(".cart_totals .wc-proceed-to-checkout");
		if (target) {
			let bannerObserver = observeBanner(target);

			document.addEventListener("updated_wc_div", (e) => {
				const newTarget = document.querySelector(".cart_totals .wc-proceed-to-checkout");
				if (!newTarget) return;

				if (typeof bannerObserver !== "undefined") {
					bannerObserver.disconnect();
				}

				bannerObserver = observeBanner(newTarget);
			});
		}

		document.addEventListener("updated_wc_div", showToasts);
	};

	attachCartListeners();
	setProceedToCheckoutObserver();

	// Hack the autoscrolling done in cart.js by WooCommerce
	jQuery(document).ready(function ($) {
		$(document).ajaxComplete(function () {
			if ($("body").hasClass("woocommerce-checkout") || $("body").hasClass("woocommerce-cart")) {
				jQuery("html, body").stop();
			}
		});
	});
})();

export default wooCart;
